package com.anjuros.website.redesign.sections.contactforms

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.redesign.components.RdSection
import com.anjuros.website.redesign.components.RdSectionHead
import com.anjuros.website.redesign.styles.RdBenefitsGridStyle
import com.anjuros.website.redesign.styles.RdH3Style
import com.anjuros.website.redesign.styles.RdSectionFlushTopStyle
import com.anjuros.website.redesign.styles.RdSectionStyle
import com.anjuros.website.redesign.util.RdText
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

private val Benefits = listOf(
    RdText.FORMS_BENEFIT1_TITLE to RdText.FORMS_BENEFIT1_TEXT,
    RdText.FORMS_BENEFIT2_TITLE to RdText.FORMS_BENEFIT2_TEXT,
    RdText.FORMS_BENEFIT3_TITLE to RdText.FORMS_BENEFIT3_TEXT,
    RdText.FORMS_BENEFIT4_TITLE to RdText.FORMS_BENEFIT4_TEXT,
    RdText.FORMS_BENEFIT5_TITLE to RdText.FORMS_BENEFIT5_TEXT,
    RdText.FORMS_BENEFIT6_TITLE to RdText.FORMS_BENEFIT6_TEXT,
)

@Composable
fun ContactFormsBenefitsSection() {
    RdSection(
        id = "benefits",
        labelledBy = "benefits-h",
        modifier = RdSectionStyle.toModifier().then(RdSectionFlushTopStyle.toModifier()),
    ) {
        RdSectionHead(RdText.FORMS_BENEFITS_EYEBROW, "benefits-h", RdText.FORMS_BENEFITS_TITLE, RdText.FORMS_BENEFITS_LEDE)
        Div(RdBenefitsGridStyle.toModifier().toAttrs()) {
            Benefits.forEach { (title, text) ->
                Div {
                    H3(RdH3Style.toModifier().toAttrs()) { Text(LocalText(title)) }
                    P { Text(LocalText(text)) }
                }
            }
        }
    }
}
